import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import GeneralInfo from "./GeneralInfo";
import * as constants from "../../Components/constants";
import { Paper } from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import LanguageOutlinedIcon from "@mui/icons-material/LanguageOutlined";
const BASE_URL = constants.BASE_URL;

const GroupSetting = ({ groupID, role }) => {
  const [data, setData] = React.useState(null);
  const [isLoading, setLoading] = React.useState(false);

  React.useEffect(() => {
    setLoading(true);
    fetch(`${BASE_URL}/group/${groupID}/group-detail/`)
      .then((res) => res.json())
      .then((data) => {
        setData(data?.group);
        setLoading(false);
      });
  }, [groupID]);

  if (isLoading) return <p>Loading...</p>;
  if (!data) return <p>No profile data</p>;
  return (
    <Container className="mt-2">
      {role === "Creator" ? (
        <GeneralInfo groupID={groupID} />
      ) : (
        <Row>
          <Paper className="p-4 rounded-3" elevation={0}>
            <h5 className="my-3">General Information</h5>
            <Col>
              {/* -----About section-----  */}
              <div>
                <h6>About</h6>
                <div
                  style={{ backgroundColor: "#ECECEC" }}
                  className="p-3 rounded-4 text-break"
                >
                  <span>{data.about}</span>
                </div>
              </div>

              {/* -----Location section-----  */}
              <div className="py-2">
                <h6>Location</h6>
                <div
                  style={{ backgroundColor: "#ECECEC" }}
                  className="p-2 rounded-4"
                >
                  <span className="mx-2">{data.location}</span>
                </div>
              </div>

              {/* -----Phone number section-----  */}
              <div className="py-2">
                <h6>Phone number</h6>
                <div
                  style={{ backgroundColor: "#ECECEC" }}
                  className="p-2 rounded-4"
                >
                  <span className="mx-2">{data.phone_no}</span>
                </div>
              </div>

              {/* -----Website link section-----  */}
              <div className="py-2">
                <h6>Website link</h6>
                <div
                  style={{ backgroundColor: "#ECECEC" }}
                  className="p-2 rounded-4"
                >
                  <a
                    href={`${
                      data.facebook_link
                        ? data.facebook_link
                        : `/group/${groupID}`
                    }`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mx-2"
                  >
                    <FacebookIcon sx={{ color: "#1877f2", fontSize: "28px" }} />
                  </a>
                  <a
                    href={`${
                      data.linkend_link
                        ? data.linkend_link
                        : `/group/${groupID}`
                    }`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mx-2"
                  >
                    <LinkedInIcon sx={{ color: "#1877f2", fontSize: "28px" }} />
                  </a>
                  <a
                    href={`${
                      data.instagram_link
                        ? data.instagram_link
                        : `/group/${groupID}`
                    }`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mx-2"
                  >
                    <InstagramIcon
                      sx={{ color: "#ac3ba5", fontSize: "28px" }}
                    />
                  </a>

                  <a
                    href={`${
                      data.others_link ? data.others_link : `/group/${groupID}`
                    }`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mx-2"
                  >
                    <LanguageOutlinedIcon
                      sx={{ color: "#405DE6", fontSize: "28px" }}
                    />
                  </a>
                </div>
              </div>
            </Col>
          </Paper>
          {/* <GroupStatic /> */}
        </Row>
      )}
    </Container>
  );
};

export default GroupSetting;
